// api/home.js
import request from '../utils/requests'



export default {
  // 获取轮播图
  getBanner (params) {
    return request({
      url: '/user/banner/list',
      method: 'get',
      params
    })
  },
  // 根据导航栏id查看轮播图列表
  // getChildTime (params) {
  //   return request({
  //     url: '/user/banner/tabBarList',
  //     method: 'get',
  //     params
  //   })
  // },

  // 查询文章列表
  getWenZhang (params) {
    return request({
      url: '/user/article/list',
      method: 'get',
      params
    })
  },
  // 查询链家文章
  getLinkWenZhang (params) {
    return request({
      url: '/user/article/getConnectionList',
      method: 'get',
      params
    })
  },
  // 根据id查询详情
  getDetail (params) {
    return request({
      url: '/user/article/info',
      method: 'get',
      params
    })
  },
  // 根据id查询下面页数
  getPage (params) {
    return request({
      url: '/user/article/getPage',
      method: 'get',
      params
    })
  },
  // 获取顶部导航
  getNav (params) {
    return request({
      url: '/user/tabBar/list',
      method: 'get',
      params
    })
  },
  // 根据id查看上下级导航栏
  getTarBarInfo (params) {
    return request({
      url: '/user/tabBar/upDownInfo',
      method: 'get',
      params
    })
  },
  // 搜索
  search (params) {
    return request({
      url: '/user/search/list',
      method: 'get',
      params
    })
  },
  // 查询上一页
  getPreviousPage (params) {
    return request({
      url: '/user/article/getPreviousPage',
      method: 'get',
      params
    })
  },
  // 查询下一页
  getNextPage (params) {
    return request({
      url: '/user/article/getNextPage',
      method: 'get',
      params
    })
  },
  // 查询单个导航
  getTabBarOne (params) {
    return request({
      url: '/user/tabBar/articleTabBar',
      method: 'get',
      params
    })
  },
  /**
   * 获取轮播图详情分页
   * */
  getBannerDetail (params) {
    return request({
      url: '/user/tabBar/bannerTabBar',
      method: 'get',
      params
    })
  },
  /**
   * 获取首页轮播图分页上一页
   * */
  getBannerPrevious(params){
    return request({
      url: 'user/banner/getPreviousPage',
      method: 'get',
      params
    })
  },
  /**
   * 获取首页轮播图分页下一页
   * */
  getBannerNext(params){
    return request({
      url: '/user/banner/getNextPage',
      method: 'get',
      params
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/home.js